import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'interest'
})
export class InterestPipe implements PipeTransform {

    transform(value: string, ...args: unknown[]): string {
        switch (value) {
            case 'low':
                return 'Gering';
            case 'medium':
                return 'Mittel';
            case 'high':
                return 'Groß';
            default:
                return '';
        }
    }

}
